import React, { useId } from 'react';

// A small soft-clay taxi seen from slightly above at a three-quarter angle,
// nose pointing down: yellow body, navy windows, light from the top-left.
function ClayTaxi({ size = 36, className = '' }) {
  const id = useId().replace(/:/g, '');
  const body = `taxi-body-${id}`;
  const glass = `taxi-glass-${id}`;
  const soft = `taxi-soft-${id}`;

  return (
    <svg
      viewBox="0 0 40 52"
      width={size}
      height={(size * 52) / 40}
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id={body} x1="0.1" y1="0" x2="0.9" y2="1">
          <stop offset="0" stopColor="#FFEAB0" />
          <stop offset="0.45" stopColor="#F2C94C" />
          <stop offset="1" stopColor="#C7951C" />
        </linearGradient>
        <linearGradient id={glass} x1="0.2" y1="0" x2="0.8" y2="1">
          <stop offset="0" stopColor="#43548F" />
          <stop offset="1" stopColor="#0A1130" />
        </linearGradient>
        <filter id={soft} x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="1.6" />
        </filter>
      </defs>
      <ellipse cx="22" cy="47" rx="13" ry="3.2" fill="#0A1130" opacity="0.45" filter={`url(#${soft})`} />
      <rect x="5" y="9" width="5" height="9" rx="2.5" fill="#0A1130" />
      <rect x="30" y="9" width="5" height="9" rx="2.5" fill="#0A1130" />
      <rect x="5" y="31" width="5" height="9" rx="2.5" fill="#0A1130" />
      <rect x="30" y="31" width="5" height="9" rx="2.5" fill="#0A1130" />
      <rect x="8" y="3" width="24" height="42" rx="10" fill={`url(#${body})`} />
      <rect x="12" y="9" width="16" height="6" rx="3" fill={`url(#${glass})`} />
      <rect x="12" y="16" width="16" height="12" rx="4" fill="#FFE08A" />
      <rect x="16" y="19.5" width="8" height="4.5" rx="1.6" fill="#0E1739" />
      <path d="M11.5 30 H28.5 L27 37 Q26.6 38.5 25 38.5 H15 Q13.4 38.5 13 37 Z" fill={`url(#${glass})`} />
      <rect x="11" y="41" width="5" height="2.4" rx="1.2" fill="#FFF7DA" />
      <rect x="24" y="41" width="5" height="2.4" rx="1.2" fill="#FFF7DA" />
      <ellipse cx="13.5" cy="10" rx="2" ry="6" fill="#fff" opacity="0.55" filter={`url(#${soft})`} />
    </svg>
  );
}

export default ClayTaxi;
